import { c as _c } from "react/compiler-runtime";
import { zodResolver } from '@common/utils';
import { z } from '@core/utils';
import { useForm } from 'react-hook-form';
export interface InquiryFormParams {
  fileUrlList: string[];
  title: string;
  contents: string;
  privateYN: boolean;
}
const schema = z.object({
  fileUrlList: z.array(z.string()),
  title: z.string({
    error: '제목을 입력해주세요.'
  }).min(1, '제목을 입력해주세요.'),
  contents: z.string({
    error: '내용을 입력해주세요.'
  }).min(1, '내용을 입력해주세요.'),
  privateYN: z.boolean()
}).refine(data => data.privateYN !== undefined, {
  message: '비밀글 여부를 선택해주세요.',
  path: ['privateYN']
});
export const useInquiryForm = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(schema);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: t0,
      mode: "onBlur",
      defaultValues: {
        privateYN: false,
        fileUrlList: [],
        title: "",
        contents: ""
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const form = useForm(t1);
  let t2;
  if ($[2] !== form) {
    t2 = {
      form
    };
    $[2] = form;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};